<template>
<div class="c-hype c-home c-home--has-grid">
    <GridBackground />
    <div class="c-hype__slider">
        <slick class="c-hype__list" v-if="video_content" :options="slick_options" ref="slick">
            <div class="c-hype__group-container" v-for="(group,index) in video_content" :key="index">
                <div class="c-hype__group">
                    <div class="c-hype__item" v-for="(item,index) in group" :key="index">
                        <div class="c-hype__media-container">
                            <div class="c-hype__media" @click="open_video_modal(item.id)">
                                <img :src="item.poster" :alt="item.title"/>
                            </div>
                        </div>
                                <div class="c-hype__media-title"  @click="open_video_modal(item.id)">WATCH: {{item.title}}</div>
                    </div>
                </div>
            </div>
        </slick>
    </div>
    <Undefeated />
    <GlitchText :text="glitch_text"/>
    <ModalVideo v-model="open_modal" :video="active_video" v-on:input="open_modal = false"/> 
</div>
</template>

<script>
import axios from 'axios'
import Slick from 'vue-slick'
import '../../node_modules/slick-carousel/slick/slick.css'
import _ from 'lodash'
import GridBackground from '@/components/GridBackground'
import GlitchText from '@/components/GlitchText.vue'
import ModalVideo from '@/components/ModalVideo'
import Undefeated from '@/components/Undefeated.vue'

export default {
    name: 'HomeHype',

    components: {
        Slick,
        GridBackground,
        GlitchText,
        ModalVideo,
        Undefeated
    },

    data: () => ({
        video_data: [],
        slick_options: {
            slidesToShow: 1,
            slidesToScroll:1,
            infinite:false
        },
        open_modal: false,
        active_video:'',
        glitch_text: 'BEYOND HYPE.'
    }),

    methods: {
        get_data() {
            return new Promise((resolve) => {
               
                axios.get('/services/allaccess.ashx/media/get?mediaCount=40&type=Archive&sport=24&category=24')
                .then(response => {
                   this.video_data = response.data;
                   resolve();
                });

            });
        },
        open_video_modal(id){
            this.active_video = 'https://lsusports.net/showcase/embed.aspx?Archive=' + id + '&autoplay=false';
            this.open_modal = true;
        }
    },
    computed:{
        video_content(){
            let count = this.$mq == 'sm' ? 1 : this.$mq == 'md' ? 4 : 9;
            return _.chunk(this.video_data, count);
        }
    },
    created() {
        this.get_data();
    },

    watch: {
            video_content: function () {

            this.$refs.slick.destroy()
            
            this.$nextTick(() => {
                this.$refs.slick.create()
            });
        }
    }
}
</script>

<style lang="scss">
    @import "../styles/imports";

    .c-hype{
        display: block;
        width:100vw;
        position:relative;
        z-index:5;
        padding-bottom:80px;
        @include flex-container;
        @include flex-column;
        @include align-stretch;
        button.slick-prev, button.slick-next{
            @include appearance;
            position: absolute;
            bottom:0;
            left:12px;
            color:$white;
            z-index: 10;
            width: 48px;
            height: 48px;
            font-size: 0;           
            transition:0.3s;
            &::after{
                position: absolute;
                top: 50%;
                left:50%;
                font-family: 'feather';
                content:'\e828';
                font-size: 24px;
                color:$white;
                @include transform(translate(-50%,-50%));
                transition: 0.2s;
            }
            &:hover{
                cursor: pointer;
                &::after{
                    color: $gold;
                }
            }
        }
        button.slick-next{
            left:auto;
            right:12px;
            &::after{
                content:'\e829';
            }
        }
        button.slick-disabled{
            opacity:0;
            pointer-events:none;
        }
    }
    .c-hype__slider{
        margin:auto 0;
    }

    .c-hype__list{
        width:100%;
        padding:0 24px 60px;
        margin: 0 auto;
    }
    .c-hype__group{
        @include flex-container;
        @include flex-wrap;
    }
    .c-hype__item{
        @include flex-item(0 0 auto);
        width:100%;
        position:relative;
        overflow: hidden;

        
    }

    .c-hype__media-container{
        overflow:hidden;
    }
    .c-hype__media-title{
        width:100%;
        padding:8px 24px;
        text-align:center;
        z-index: 4;
        font-size:0.875rem;
        letter-spacing: 0.04rem;
        display:inline-block;
        border:solid 1px $gold;
        background:rgba(0,0,0,0.75);
        transition:0.2s;
        text-transform: uppercase;
        margin-top:24px;
       
    }
    .c-hype__media{
        position:relative;
        width:100%;
        overflow:hidden;
        padding-bottom:56.25%;
        background:#111;
        
        transition:transform 0.4s 0.6s;
        &:hover{
            cursor: pointer;
            
            &::after{
                border-left-color:$gold;
                left:20px;
            }
        }
        &::after{
            position: absolute;
            top: 50%;
            left: 50%;
            @include transform(translate(-50%,-50%));
            border-top: 20px solid transparent;
            content:'';
            border-left: 30px solid $white;
            border-bottom: 20px solid transparent;
            transition:0.2s;
        }
        img{
            position:absolute;
            top:0;
            left:0;
            width:100%;
            opacity:0.6;
        }
    }    


    @media all and (min-width:$small-breakpoint){
        .c-hype{
            display:block;
            padding-bottom:0;
            button.slick-prev, button.slick-next{
                bottom:auto;
                top:50%;
                left:48px;
                 @include transform(translateY(-50%));
            }
            button.slick-next{
                left:auto;
                right:48px;
            }
        }
        .c-hype__media-title{
            position:absolute;
            margin-top:0;
            top:50%;
            right:12px;
            width:calc(100% - 60px);
            @include transform(translate(100%,-50%));
             opacity:0;
             pointer-events: none;
        }
        .c-hype__slider{
            margin-bottom:0;
        }
        .c-hype__list{
            padding:0 20%;
        }
        .c-hype__item{
            width:50%;
            &:hover{
                .c-hype__media-title{
                @include transform(translate(0,-50%));
                opacity:1;
            }

            }
        }
        .c-hype__media{
            @include transform(translateX(-100%));
        }
        .c-hype__item{
            &:nth-child(2){
                .c-hype__media{
                    @include transform(translateY(-100%));
                }
            }   
            &:nth-child(3){
                .c-hype__media{
                    @include transform(translateY(100%));
                }
            }
            &:nth-child(4){
                .c-hype__media{
                    @include transform(translateY(-100%));
                }
            }  
            &:nth-child(5){
                .c-hype__media{
                    @include transform(translateX(100%));
                }
            }
            &:nth-child(6){
                .c-hype__media{
                    @include transform(translateY(-100%));
                }
            } 
            &:nth-child(7){
                .c-hype__media{
                    @include transform(translateX(100%));
                }
            }
            &:nth-child(8){
                .c-hype__media{
                    @include transform(translateY(-100%));
                }
            }                
        }
        .s-page.active{
            .c-hype__media{
                @include transform(none);
            }
        }
    }
    @media all and (min-width:$medium-breakpoint){
        .c-hype__item{
            width:33.3333%;
        }
    }
</style>